import angular from 'angular';

export default angular.module('app.services.userExploreUtil', [])
  .service('userExploreConstants', () => {
    return {
      getAgeBucketStringFromDriudBucket(trendName) {
        if(this.ageDriudBucketNameToRange[trendName]) {
          if(this.ageDriudBucketNameToRange[trendName].to) {
            return this.ageDriudBucketNameToRange[trendName].from + ' - ' + this.ageDriudBucketNameToRange[trendName].to
          } else {
            return this.ageDriudBucketNameToRange[trendName].from + '+'
          }
        } else {
          return trendName;
        }
      },
      ageDriudBucketNameToRange: {
        '17': {from: 0, to: 17},
        '24': {from: 18, to: 24},
        '34': {from: 25, to: 34},
        '44': {from: 35, to: 44},
        '54': {from: 45, to: 54},
        '64': {from: 55, to: 64},
        '65': {from: 65}
      },
      ageSliderTickToRange: {
        '1.00': {from: 0, to: 17},
        '2.00': {from: 18, to: 24},
        '3.00': {from: 25, to: 34},
        '4.00': {from: 35, to: 44},
        '5.00': {from: 45, to: 54},
        '6.00': {from: 55, to: 64},
        '7.00': {from: 65, to: 65}
      },
      paymentAmountSliderTickToValue: {
        '1.00': {from: 0, to: 0},
        '2.00': {from: 0, to: 1},
        '3.00': {from: 1, to: 2},
        '4.00': {from: 2, to: 3},
        '5.00': {from: 3, to: 4},
        '6.00': {from: 4, to: 5},
        '7.00': {from: 5, to: 10},
        '8.00': {from: 10, to: 15},
        '9.00': {from: 15, to: 20},
        '10.00': {from: 20, to: 30},
        '11.00': {from: 30, to: 40},
        '12.00': {from: 40, to: 50},
        '13.00': {from: 50, to: 100},
        '14.00': {from: 100, to: 101}
      },
      activeDaysSliderTickToValue: {
        '1.00': {from: 0, to: 0},
        '2.00': {from: 1, to: 1},
        '3.00': {from: 1, to: 3},
        '4.00': {from: 3, to: 7},
        '5.00': {from: 7, to: 14},
        '6.00': {from: 14, to: 30},
        '7.00': {from: 30, to: 60},
        '8.00': {from: 60, to: 100},
        '9.00': {from: 100, to: 300},
        '10.00': {from: 300, to: 301}
      },
      sessionsSliderTickToValue: {
        '1.00': {from: 0, to: 0},
        '2.00': {from: 1, to: 1},
        '3.00': {from: 1, to: 2},
        '4.00': {from: 2, to: 3},
        '5.00': {from: 3, to: 4},
        '6.00': {from: 4, to: 5},
        '7.00': {from: 5, to: 10},
        '8.00': {from: 10, to: 15},
        '9.00': {from: 15, to: 20},
        '10.00': {from: 20, to: 30},
        '11.00': {from: 30, to: 31}
      },
      otherAppsSliderTickToValue: {
        '1.00': {from: 0, to: 0},
        '2.00': {from: 0, to: 1},
        '3.00': {from: 1, to: 2},
        '4.00': {from: 2, to: 3},
        '5.00': {from: 3, to: 4},
        '6.00': {from: 4, to: 5},
        '7.00': {from: 5, to: 10},
        '8.00': {from: 10, to: 15},
        '9.00': {from: 15, to: 20},
        '10.00': {from: 20, to: 30},
        '11.00': {from: 30, to: 31}
      },
      transactionsSliderTickToValue: {
        '1.00': {from: 0, to: 0},
        '2.00': {from: 0, to: 1},
        '3.00': {from: 1, to: 2},
        '4.00': {from: 2, to: 3},
        '5.00': {from: 3, to: 4},
        '6.00': {from: 4, to: 5},
        '7.00': {from: 5, to: 10},
        '8.00': {from: 10, to: 15},
        '9.00': {from: 15, to: 20},
        '10.00': {from: 20, to: 30},
        '11.00': {from: 30, to: 40},
        '12.00': {from: 40, to: 50},
        '13.00': {from: 50, to: 51}
      }
    };
  });



/** WEBPACK FOOTER **
 ** ./src/services/userExploreConstants.js
 **/